import {
    Component,
    Input,
    TemplateRef,
    ViewChild,
    ChangeDetectionStrategy
} from "@angular/core";

@Component({
    selector: "rask-map-widget-tab",
    templateUrl: "./map-widget-tab.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./map-widget-tab.component.scss"]
})
export class MapWidgetTabComponent {

    @Input() id: string;
    @Input() icon: string;
    @Input() index: number;
    @Input() tooltip: string;
    @Input() disabled: boolean;
    @Input() counter: number;
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("open") set list(val: boolean) {
        this.isOpen = val;
    }
    isOpen = false;

    @ViewChild(TemplateRef) template: TemplateRef<any>;
}
